import { Outlet, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Root layout component that handles global scroll-to-top behavior
 * on route changes. Wraps all routes in the application.
 */
export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <Outlet />;
}
